import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { setStatusFail } from "../statusFail/statusFailSlice";
import Cookies from "js-cookie";
const initialState = {
  diagnostics: [],
  diagnostic: null,
  isLoading: false,
  error: null,
  totalPages:1
};
const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
export const getAllDiagnostic = createAsyncThunk(
  "diagnostic/getAll",
  async ({locationId,page,limit,sortBy,order}, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/diagnostics?page=${page}&limit=${limit}&sortBy=${sortBy}&order=${order}`,{
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
          'location-id':locationId,
          tenantId: Cookies.get("TenantId")
        },
      });
       
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
             const route = "/status-failed"
             await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
           }
           return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);

export const getDiagnosticById = createAsyncThunk(
  "diagnostic/getById",
  async (id, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/diagnostics/${id}`,{
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
     
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
             const route = "/status-failed"
             await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
           }
           return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);

export const createDiagnostic = createAsyncThunk(
  "diagnostic/create",
  async (data, { rejectWithValue,dispatch }) => {
    try {
      const resposne = await axios.post(`${ADMIN_URL}/diagnostics`, data, {
        headers: {  
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      })
      return resposne.data.data
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
             const route = "/status-failed"
             await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
           }
           return rejectWithValue(error.response?.data?.error?.message);
    }
  }
);

export const updateDiagnostic = createAsyncThunk(
  "diagnostic/update",
  async ({ id, data }, { rejectWithValue,dispatch }) => {
    try {
       const response= await axios.patch(`${ADMIN_URL}/diagnostics/${id}`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
       })


       return { id, data: response.data.data };
    } catch (error) {
     if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
            const route = "/status-failed"
            await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
          } 
           const errorMessage = 
        error.response?.data?.message ||           
        error.response?.data?.error?.message ||    
        error.response?.data?.error ||             
        error.message ||                           
        "Something went wrong";
      
      return rejectWithValue(errorMessage);
    }
  }
);

const diagnosticSlice = createSlice({
  name: "diagnostic",
  initialState,
  reducers: {
    clearErrorDiagnostic: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDiagnostic.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllDiagnostic.fulfilled, (state, action) => {
        state.isLoading = false;
        state.diagnostics = action.payload.data;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getAllDiagnostic.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getDiagnosticById.pending, (state) => {
        state.isLoading = true;
        state.error=null
      })
      .addCase(getDiagnosticById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.diagnostic = action.payload;
      })
      .addCase(getDiagnosticById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createDiagnostic.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createDiagnostic.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.diagnostics.push(action.payload);
      })
      .addCase(createDiagnostic.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateDiagnostic.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateDiagnostic.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.diagnostics.findIndex(
          (diagnostic) => diagnostic._id === action.payload.id
        );
        if (index !== -1) {
          state.diagnostics[index] = {...state.diagnostics[index],...action.payload.data};
        }
      })
      .addCase(updateDiagnostic.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearErrorDiagnostic } = diagnosticSlice.actions;

export default diagnosticSlice.reducer;
